import { cloneDeep } from 'lodash'
import router from '@/router'
import util from '@/utils/util'

export default {
  namespaced: true,
  state: {
    isLoaded: false, //tab信息是否加载
    tabs: [], //当前tab集合
    allTabs: [] //通过权限的tab集合
  },
  actions: {
    /**
     * 确认已经加载tab信息
     */
    isLoaded({ state }) {
      if (state.isLoaded) {
        return Promise.resolve()
      } else {
        return new Promise(resolve => {
          const timer = setInterval(() => {
            if (state.isLoaded) {
              resolve(clearInterval(timer))
            }
          }, 10)
        })
      }
    },

    /**
     * 跳转页面
     */
    page(_, tab) {
      router.push({
        name: tab.name,
        params: !tab.disableCache && tab.params ? tab.params : {},
        query: !tab.disableCache && tab.query ? tab.query : {}
      })
    },

    /**
     * 加载tab信息
     */
    async load({ state, dispatch }) {
      const fixedTabs = state.allTabs.filter(tab => tab.fixedTab)
      const tabs = util.db
        .get('tab.tabs', [], true)
        .filter(item => !fixedTabs.find(page => page.path === item.path))
        .filter(item => !!state.allTabs.find(page => page.path === item.path))
      state.tabs = [...fixedTabs, ...tabs]
      await dispatch('save')
      state.isLoaded = true
    },

    /**
     * 保存tab信息
     */
    async save({ state }) {
      util.db.set('tab.tabs', state.tabs, true)
    },

    /**
     * 打开tab
     */
    async open({ state, dispatch }, target) {
      const tab = state.allTabs.find(page => page.path === target.path)
      const openedTab = state.tabs.find(tab => tab.path === target.path)
      if (tab) {
        if (openedTab) {
          openedTab.params = target.params || {}
          openedTab.query = target.query || {}
        } else {
          state.tabs.push(
            cloneDeep({
              ...tab,
              params: target.params || {},
              query: target.query || {}
            })
          )
        }
        await dispatch('save')
      }
    },

    /**
     * tab重新排序
     */
    async sort({ state, dispatch }, { oldIndex, newIndex }) {
      const tab = state.tabs[oldIndex]
      state.tabs.splice(oldIndex, 1)
      state.tabs.splice(newIndex, 0, tab)
      await dispatch('save')
    },

    /**
     * 关闭tab
     */
    async close({ state, dispatch }, { path, current }) {
      const pos = state.tabs.findIndex(tab => tab.path === path)
      if (pos >= 0) {
        state.tabs.splice(pos, 1)
        if (current === path) {
          dispatch('page', state.tabs[state.tabs.length >= pos + 1 ? pos : pos - 1])
        }
        await dispatch('save')
      }
    },

    /**
     * 关闭左侧tab
     */
    async closeLeft({ state, dispatch }, { path, current }) {
      const pos = state.tabs.findIndex(tab => tab.path === path)
      const tab = pos >= 0 ? state.tabs[pos] : null
      const openedTab = state.tabs.find(tab => tab.path === current)
      if (pos >= 0) {
        state.tabs = state.tabs.filter((tab, index) => index >= pos || tab.fixedTab)
        if (!state.tabs.find(tab => tab.path === current) && openedTab) {
          dispatch('page', tab)
        }
        await dispatch('save')
      }
    },

    /**
     * 关闭右侧tab
     */
    async closeRight({ state, dispatch }, { path, current }) {
      const pos = state.tabs.findIndex(tab => tab.path === path)
      const tab = pos >= 0 ? state.tabs[pos] : null
      const openedTab = state.tabs.find(tab => tab.path === current)
      if (pos >= 0) {
        state.tabs = state.tabs.filter((tab, index) => index <= pos || tab.fixedTab)
        if (!state.tabs.find(tab => tab.path === current) && openedTab) {
          dispatch('page', tab)
        }
        await dispatch('save')
      }
    },

    /**
     * 关闭其余tab
     */
    async closeOther({ state, dispatch }, { path, current }) {
      const pos = state.tabs.findIndex(tab => tab.path === path)
      const tab = pos >= 0 ? state.tabs[pos] : null
      const openedTab = state.tabs.find(tab => tab.path === current)
      if (pos >= 0) {
        state.tabs = state.tabs.filter((tab, index) => index === pos || tab.fixedTab)
        if (!state.tabs.find(tab => tab.path === current) && openedTab) {
          dispatch('page', tab)
        }
        await dispatch('save')
      }
    },

    /**
     * 关闭全部tab
     */
    async closeAll({ state, dispatch }, { current }) {
      state.tabs = state.tabs.filter(tab => tab.fixedTab)
      if (!state.tabs.find(tab => tab.path === current)) {
        dispatch('page', state.tabs[0])
      }
      await dispatch('save')
    }
  },
  mutations: {
    /**
     * 设置通过校验的页面列表
     */
    setAllTabs(state, tabs) {
      state.allTabs = tabs
    }
  }
}
